import React, { useEffect, useState } from "react";

const titles = ["Android Developer", "Flutter App Developer"];

const SliderAnimation = () => {
  const [titleIndex, setTitleIndex] = useState(0);
  const [exiting, setExiting] = useState(false);

  // Rotating title
  useEffect(() => {
    const prefersReduced = window.matchMedia("(prefers-reduced-motion: reduce)").matches;
    if (prefersReduced) return;
    const interval = setInterval(() => {
      setExiting(true);
      setTimeout(() => {
        setTitleIndex((i) => (i + 1) % titles.length);
        setExiting(false);
      }, 250);
    }, 2800);
    return () => clearInterval(interval);
  }, []);

  return (
    <section className="d2-hero" id="home" aria-label="Introduction">
      <div className="hero-grid-bg" aria-hidden="true" />
      <div className="hero-glow-el" aria-hidden="true" />
      <div className="d2-container hero-content">
        <div className="hero-badge reveal">
          <span className="hero-badge-dot" aria-hidden="true" />
          Available for freelance
        </div>

        <h1 className="hero-title reveal reveal-delay-1">
          Lakshay Parnami<span style={{ color: "var(--accent)" }}>.</span>
        </h1>

        <div className="hero-rotating-wrap reveal reveal-delay-2">
          <span className="hero-role-prefix">I'm a</span>
          <span className={`hero-rotating${exiting ? " exiting" : ""}`} aria-live="polite">
            {titles[titleIndex]}
          </span>
        </div>

        <p className="hero-subtitle reveal reveal-delay-3">
          I develop mobile applications for all formats, specializing in creating scalable, and developer friendly architectures.
        </p>

        <div className="hero-actions reveal reveal-delay-4">
          <a href={`${process.env.PUBLIC_URL}/resume-lakshay-parnami.pdf`} className="btn-primary" aria-label="Download resume PDF" target="_blank" rel="noopener noreferrer">
            <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true">
              <path d="M21 15v4a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-4" />
              <polyline points="7 10 12 15 17 10" />
              <line x1="12" y1="15" x2="12" y2="3" />
            </svg>
            Download Resume
          </a>
          <a href="#contactus" className="btn-secondary">Get in touch</a>
        </div>

        <div className="hero-contact-row reveal reveal-delay-4">
          <div className="hero-contact-item">
            <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true">
              <path d="M22 16.92v3a2 2 0 0 1-2.18 2 19.79 19.79 0 0 1-8.63-3.07A19.5 19.5 0 0 1 4.69 12a19.79 19.79 0 0 1-3.07-8.67A2 2 0 0 1 3.5 1.2h3a2 2 0 0 1 2 1.72c.127.96.361 1.903.7 2.81a2 2 0 0 1-.45 2.11L7.91 8.8a16 16 0 0 0 6 6l.86-.86a2 2 0 0 1 2.11-.45c.907.339 1.85.573 2.81.7a2 2 0 0 1 1.72 2.03z" />
            </svg>
            <a href="tel:+918107958922">+91 8107 958922</a>
          </div>
          <div className="hero-contact-item">
            <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true">
              <rect width="20" height="16" x="2" y="4" rx="2" />
              <path d="m22 7-8.97 5.7a1.94 1.94 0 0 1-2.06 0L2 7" />
            </svg>
            <a href="mailto:laksh.parnami@gmail.com">laksh.parnami@gmail.com</a>
          </div>
        </div>
      </div>
    </section>
  );
};

export default SliderAnimation;
